module.exports = __webpack_public_path__ + "static/media/nfse-icon.bce837f2.png";